
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CaseSubject')
export class CaseSubject {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('subject', String, true)
    subject = '';

    @JsonProperty('subject_ar', String, true)
    subjectAr = '';
}